module.exports = __webpack_public_path__ + "img/trip_11.46764f95.jpg";